import { ScaleBand, axisLeft, select } from "d3";
import React, { useEffect, useRef } from "react";

import { MarkerPlayer } from "../../../../types";
import styles from "./player-axis.module.scss";

export interface PlayerAxisProps {
  xOffset: number;
  yOffset: number;
  scale: ScaleBand<string>;
  players: MarkerPlayer[];
}

export const PlayerAxis = ({ xOffset, yOffset, scale, players }: PlayerAxisProps) => {
  const axisRef = useRef<SVGGElement>(null);

  useEffect(() => {
    const axisElement = axisRef.current;

    if (axisElement) {
      const axis = axisLeft(scale)
        .tickSize(25)
        .tickFormat((d) => players.find((player) => player.id === d)?.label || "O");

      select<SVGGElement, null>(axisElement).call(axis);
    }

    // cleanup axis when re-render
    return () => {
      select(axisElement).selectAll("*").remove();
    };
  }, [scale, players]);

  return <g ref={axisRef} className={styles.playerAxis} transform={`translate(${xOffset}, ${yOffset})`}></g>;
};
